<p-dialog
  [visible]="true"
  (onHide)="closeDialog()"
  (onHide)="closeDialog()"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="custom-dialog"
  [style]="{ width: '600px', maxHeight: '600px' }"
  [appendTo]="'body'"
  (onHide)="closeDialog()"
  aria-labelledby="add-product-header"
>
  <ng-template pTemplate="header">
    <div class="flex align-items-center gap-2">
      <i class="pi pi-shopping-cart text-primary"></i>
      <span id="add-product-header" class="font-semibold text-xl">
        {{
          activeEditProduct
            ? ('ADMIN.SUBSCRIPTION.EDIT_PRODUCT' | translate)
            : ('ADMIN.SUBSCRIPTION.ADD_PRODUCT' | translate)
        }}
      </span>
    </div>
  </ng-template>

  <div class="p-4">
    <form [formGroup]="productCreateForm">
      <div class="grid">
        <!-- Product Selection -->
        <div class="col-12">
          <label for="product-select" class="block text-900 font-medium mb-2">
            {{ 'ADMIN.SUBSCRIPTION.PRODUCT' | translate }}
            <span class="text-red-500">*</span>
          </label>
          <p-select
            id="product-select"
            formControlName="product_id"
            [options]="products"
            optionLabel="name_primary_language"
            optionValue="id"
            [placeholder]="'ADMIN.SUBSCRIPTION.SELECT_PRODUCT' | translate"
            [filter]="true"
            filterBy="name_primary_language"
            class="w-full"
            [appendTo]="'body'"
            [loading]="loading | async"
            aria-label="product-select-dropdown"
          >
            <ng-template let-product pTemplate="item">
              <div class="flex align-items-center gap-2">
                @if (product.image_url) {
                  <img
                    [src]="product.image_url"
                    [alt]="product.name_primary_language"
                    class="w-2rem h-2rem border-round object-cover"
                  />
                }
                <div class="flex-1">
                  <div class="font-medium">
                    {{ product.name_primary_language }}
                  </div>
                  <div class="text-sm text-600">
                    {{ product.code || 'No code' }}
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template let-product pTemplate="selectedItem">
              @if (product) {
                <div class="flex align-items-center gap-2">
                  @if (product.image_url) {
                    <img
                      [src]="product.image_url"
                      [alt]="product.name_primary_language"
                      class="w-2rem h-2rem border-round object-cover"
                    />
                  }
                  <span>{{ product.name_primary_language }}</span>
                </div>
              }
            </ng-template>
          </p-select>

          @if (ProductSku?.invalid && ProductSku?.touched) {
            <div class="text-red-500 text-sm mt-1">
              @if (ProductSku?.errors?.['required']) {
                <div>
                  {{ 'ADMIN.SUBSCRIPTION.PRODUCT_REQUIRED' | translate }}
                </div>
              }
            </div>
          }
        </div>

        <!-- Amount -->
        <div class="col-12">
          <label for="amount-input" class="block text-900 font-medium mb-2">
            {{ 'ADMIN.SUBSCRIPTION.AMOUNT' | translate }}
            <span class="text-red-500">*</span>
          </label>
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon text-sm"
              ><span class=""> {{ currencySymbol }}</span></span
            >
            <!-- <p-inputNumber formControlName="base_cost_in_minor_currency" [format]="false" class="text-sm" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2"> </p-inputNumber> -->
            <app-shared-input-number
              [formGroup]="productCreateForm"
              [controlName]="Amount"
              [styleClass]="'w-full text-sm'"
              [conditionToFormat]="false"
              aria-label="base-cost-input"
            />
          </div>

          @if (Amount?.invalid && Amount?.touched) {
            <div class="text-red-500 text-sm mt-1">
              @if (Amount?.errors?.['required']) {
                <div>
                  {{ 'ADMIN.SUBSCRIPTION.AMOUNT_REQUIRED' | translate }}
                </div>
              }
              @if (Amount?.errors?.['min']) {
                <div>
                  {{ 'ADMIN.SUBSCRIPTION.AMOUNT_MIN' | translate }}
                </div>
              }
            </div>
          }
        </div>
      </div>
    </form>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <p-button
        [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
        icon="pi pi-times"
        [outlined]="true"
        (onClick)="closeDialog()"
        aria-label="cancel-button"
      />
      <p-button
        [label]="'common.BUTTONS.BUTTON-TEXT-SAVE' | translate"
        icon="pi pi-check"
        (onClick)="saveProductCreateForm()"
        [disabled]="productCreateForm.invalid"
        aria-label="save-product-button"
      />
    </div>
  </ng-template>
</p-dialog>
